import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const stats = () => {
	gsap.registerPlugin(ScrollTrigger);
	const statsBlocks = document.querySelectorAll(".stats-block");
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;

	if (!statsBlocks?.length) return;

	statsBlocks.forEach((block) => {
		const statsItems = block.querySelectorAll(".stat-item");

		if (!statsItems?.length) return;

		if (prefersReducedMotion) {
			gsap.set(statsItems, { autoAlpha: 1, y: 0 });
			return;
		}

		gsap.fromTo(
			statsItems,
			{ autoAlpha: 0, y: 50 },
			{
				autoAlpha: 1,
				y: 0,
				stagger: 0.2,
				duration: 0.5,
				ease: "power2.out",
				scrollTrigger: {
					trigger: block,
					start: "top center",
					once: true,
				},
			},
		);
	});
};

export default stats;
